import { checkServiceProvider } from './serviceProviderConfig';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({ message, Styled, permissionDenied, isPopUp }) => {
  const SERVICE_PROVIDER = window.$environment.SERVICE_PROVIDER;
  const { i18n } = useTranslation();
  const [suspendedOpen, setSuspendedOpen] = useState(false);

  useEffect(() => {
    if (isPopUp) {
      setSuspendedOpen(true);
      document.title = 'Company is suspended';
    }
  }, [isPopUp]);

  const serviceProvider = {
    gs: 'Gorilla safety',
    em: 'ELD Mandate Pro',
    trackon: 'Track On',
    tp: 'Clear Path ELD',
    spireon: 'Spireon',
    clutch: 'Clutch ELD',
    riskTheory: 'Constitutional Risk Management',
    nauto: 'Nauto',
  };

  if (isPopUp) {
    return (
      <Modal
        open={suspendedOpen}
        data={{
          header: '',
          content: () => (
            <div className="successpopup">
              <SvgIcon value={mediaUrls.confirmIcon} alt="company suspended" />
              <h2> Company is suspended. Please contact {serviceProvider[SERVICE_PROVIDER]}. </h2>
              <div className="deletePopupBtn">
                <Button
                  type="submit"
                  label={i18n.t('common.ok')}
                  onClick={() => {
                    setSuspendedOpen(false);
                  }}
                />
              </div>
            </div>
          ),
        }}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
      />
    );
  } else
    return (
      <Styled.Wrapper permissionDenied={permissionDenied}>
        {message && typeof message === 'string' ? (
          <span className="unauthorized">{message}</span>
        ) : message ? (
          message()
        ) : (
          <>
            <h1>{i18n.t('apology')}...</h1>
            <p>{i18n.t('page moved')}</p>
            <p>
              {checkServiceProvider('hasLinkAccessText', SERVICE_PROVIDER, false)}
              <a href={checkServiceProvider('hasLinkAccessHref', SERVICE_PROVIDER, false)} className="here">
                {checkServiceProvider('hasLinkAccessLabel', SERVICE_PROVIDER, false)}
              </a>
            </p>
          </>
        )}
      </Styled.Wrapper>
    );
};

Component.propTypes = {
  message: PropTypes.string.isRequired,
};
